/**
 * Launch item l8 — sends a page view on every route change and ties events
 * to the signed-in user + organization. Renders nothing; a no-op when
 * VITE_POSTHOG_KEY is unset.
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAuth } from '../../contexts/AuthContext'
import { identify, trackPageview } from '../../utils/analytics'

export function AnalyticsTracker() {
  const { pathname } = useLocation()
  const { user } = useAuth()

  useEffect(() => {
    if (user) identify(user)
  }, [user])

  useEffect(() => {
    trackPageview()
  }, [pathname])

  return null
}
